import { LocalitySelectedType, SeatsSelectedType, UserType, ZoneType } from 'data/types';
import React, { FC, useEffect, useState } from 'react';
import SeatSvg from '../../shared/Seat/SeatSvg';
import { useSocket } from 'hooks/useSocket';
import { getEnvVariables } from '../../helpers/getEnvVariables';
import ButtonPrimary from 'shared/Button/ButtonPrimary';
import ButtonSecondary from 'shared/Button/ButtonSecondary';
import SeatsBadges from './SeatsBadges';
import { useDeleteSeatsByLocalityMutation } from 'store/api';

export const Seats: FC<{
   zone: ZoneType; 
   maxSeats: number,
   endTime:string,
   localitySelected: LocalitySelectedType[],
   setLocalitySelected: React.Dispatch<React.SetStateAction<LocalitySelectedType[]>>,
   setIsOpen:React.Dispatch<React.SetStateAction<boolean>>,
  }> = (
  { zone, maxSeats,endTime,setIsOpen, localitySelected,setLocalitySelected }) => {

  const [alert, setAlert] = useState<string | null>(null);
  const [seatsNormalPurchased, setSeatsNormalPurchased] = useState<string[]>([]);
  const [seatsSubscriberPurchased, setSeatsSubscriberPurchased] = useState<string[]>([]);
  const [seatsBuying, setSeatsBuying] = useState<string[]>([]);
  const [isSaving, setIsSaving] = useState(false);
  const { REACT_APP_URL } = getEnvVariables();
  const userData = localStorage.getItem("user");
  const [deleteSeats] = useDeleteSeatsByLocalityMutation();
  
  let user:UserType;
  if (userData) {
    user = JSON.parse(userData) as UserType;
  }
  const socket = useSocket(`${REACT_APP_URL}ticket-select`, { id:zone._id, customer: user!._id });
  socket.emit("subscribe-seat", { id: zone._id, customer: user!._id });
  useEffect(() => {
    socket.on('ticket-select', (data: any) => {
      console.log(data);
      switch(data.type){
        case 'init':
          if(data.buyNormalSeat.length > 0){
            setSeatsNormalPurchased(data.buyNormalSeat[0].positions.map((seat:any)=>seat.list));
          }
          if(data.buySeat.length > 0){
            setSeatsSubscriberPurchased(data.buySeat[0].position.map((seat:any)=>seat.list));
          }
          if(data.selectSeat.length > 0){
            console.log(localitySelected);
            const seatsSocket = data.selectSeat[0].position.map((seat:any)=>seat)
            const ownSelectedSeatsZone = localitySelected.find(loc => loc._id === zone.locality)?.zones?.find(z => z._id === zone._id)?.seats;
            const ownSelectedSeats = ownSelectedSeatsZone?.filter((item:any)=>seatsSocket.includes(item)) || [];
            const buyingSeats = seatsSocket.filter((item:any)=>!ownSelectedSeats.includes(item));
            setLocalitySelected((prev)=>prev.map((item)=>item._id===zone.locality?{...item,zones:item.zones?.map((zoneItem)=>zoneItem._id===zone._id?{...zoneItem,seats:Array.from(new Set([...zoneItem.seats, ...ownSelectedSeats]))}:zoneItem)}:item));
            setSeatsBuying(buyingSeats);
          }
          break;
          case 'reserveSeatByTopic':
            if(data.customer!==user._id){
              setSeatsBuying((prev)=>[...prev,data.selectSeat.join()]);
            }
            break;
          case 'cancelSelectedSeat':
            if(data.selectSeat){
              setSeatsBuying((prev)=>prev.filter((item)=>item!==data.selectSeat));
            }
            break;
          case 'cancelSeatByTopic':
            if(data.selectSeat){
              const seatsToRemove = data.selectSeat[0].position.map((seat:any)=>seat);
              setSeatsBuying((prev)=>prev.filter((item)=>!seatsToRemove.includes(item)));
            }
            break;
      }
    });
    
    return () => {
      if(!isSaving){
        cancelSeatByTopic();
        socket.disconnect();
      }
    };
  }, [socket]);

  const cancelSeatByTopic = () => {
    socket.emit("ticket-select", {
      topic: zone._id,
      customer: user._id,
      type: "cancelSeatByTopic",
    });
    // setSelected((prev) =>
    // prev.map((item) =>
    //   item._id === zone._id ? { ...item, seats: [] } : item
    // ));
  }
  
  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
       deleteSeats(zone.locality);
        event.preventDefault();
        event.returnValue = ""; 
        setIsSaving(false);
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, []);

  const handleSelect = (seatData: string) => {
    setLocalitySelected((prev)=>{
      const localityIndex = prev.findIndex((item)=>item._id===zone.locality);
      const zoneIndex = prev?.[localityIndex]?.zones?.findIndex((item)=>item._id===zone._id);

      // Si el asiento ya está seleccionado en esta zona, lo quitamos
      if(prev[localityIndex].zones?.[zoneIndex].seats.includes(seatData)){
        socket.emit("ticket-select", {
          type: "cancelSelectedSeat",
          topic: zone._id,
          position: seatData,
          customer: user._id,
        });
        const updatedZone = {
          ...prev[localityIndex].zones?.[zoneIndex],
          seats: prev[localityIndex].zones?.[zoneIndex].seats.filter((seat) => seat !== seatData),
        };
        const updatedLocality = {
          ...prev[localityIndex],
          zones: prev[localityIndex].zones?.map((item)=>item._id===zone._id?updatedZone:item)
        };
        const newState = [
          ...prev.slice(0, localityIndex),
          updatedLocality,
          ...prev.slice(localityIndex + 1),
        ];
        return newState;
      }

      const totalSeatsSelected = prev[localityIndex].zones?.reduce(
        (total, item) => total + item.seats.length,
        0
      );

      if (totalSeatsSelected >= maxSeats) {
        setAlert(`Solo puedes seleccionar ${maxSeats} asientos`);
        setTimeout(() => setAlert(null), 2000);
        return prev;
      }

      const updatedZone = {
        ...prev[localityIndex].zones?.[zoneIndex],
        seats: [...prev[localityIndex].zones?.[zoneIndex].seats, seatData],
      };

      const updatedLocality = {
        ...prev[localityIndex],
        zones: prev[localityIndex].zones?.map((item)=>item._id===zone._id?updatedZone:item)
      };

      const newState = [
        ...prev.slice(0, localityIndex),
        updatedLocality,
        ...prev.slice(localityIndex + 1),
      ];

      socket.emit("ticket-select", {
        type: "reserveSeatByTopic",
        topic: zone._id,
        position: [seatData],
        endTime: endTime,
        locality: zone.locality,
        customer: user._id,
      });
      return newState;
    });
  };
  
  const handleSave = () => {
    setIsSaving(true);
    socket.emit("unsubscribe-seat", {
      topic: zone.locality,
      customer: user._id,
    });
    setIsOpen(false);
    socket.disconnect();
  }


  const handleCancel = () => {
    setIsSaving(false);
    socket.emit("ticket-select", {
      topic: zone._id,
      customer: user._id,
      type: "cancelSeatByTopic",
    });
    
    setLocalitySelected((prev)=>{
      const localityIndex = prev.findIndex((item)=>item._id===zone.locality);
      const zoneIndex = prev?.[localityIndex]?.zones?.findIndex((item)=>item._id===zone._id);
      const updatedZone = {
        ...prev[localityIndex].zones?.[zoneIndex],
        seats: [],
      };
      const updatedLocality = {
        ...prev[localityIndex],
        zones: prev[localityIndex].zones?.map((item)=>item._id===zone._id?updatedZone:item)
      };
      const newState = [
        ...prev.slice(0, localityIndex),
        updatedLocality,
        ...prev.slice(localityIndex + 1),
      ];
      return newState;
    }
    );
    setIsOpen(false);
  };

  return (
    <div className="w-full flex flex-col sm:rounded-2xl lg:border border-neutral-200 dark:border-neutral-700 space-y-6 sm:space-y-8 px-0 sm:p-6 xl:p-8">
      <p>* Para conservar los asientos seleccionados, asegúrate de guardar los cambios.</p>
      <SeatsBadges />
      <div className="flex flex-col sm:flex-row sm:items-center justify-center items-center">
        <div
          className="overflow-x-auto w-full py-14"
          style={{
            scrollbarWidth: 'thin',
            scrollbarColor:
              localStorage.getItem('theme') === 'dark'
                ? 'rgba(100, 116, 139, 0.4) rgba(15, 23, 42, 0.2)'
                : 'rgba(100, 116, 139, 0.4) rgba(15, 23, 42, 0.0)',
          }}
        >
          <div className="space-y-2">
            {[...Array(zone.rows)].map((_, rowIndex) => {
              let counter = 0;
              return (
                <div key={rowIndex} className="flex gap-2">
                  <div className="flex gap-2">
                    {[...Array(zone.cols)].map((_, colIndex) => {
                      const seatLabel =
                        zone.seat[0].seat_map[rowIndex].letter +
                        String(zone.seat[0].seat_map[rowIndex].start + counter).padStart(
                          2,
                          '0'
                        );
                      const seatsSelectedByZone:SeatsSelectedType = localitySelected.find((item)=>item._id===zone.locality)!.zones!.find((item)=>item._id===zone._id)!;
                      const isSelected = seatsSelectedByZone.seats?.includes(`${rowIndex+1}_${colIndex+1}`);
                      const isNormalPurchased = seatsNormalPurchased.includes(`${rowIndex+1}_${colIndex+1}`);
                      const isSubscriberPurchased = seatsSubscriberPurchased.includes(`${rowIndex+1}_${colIndex+1}`);
                      const isBuying = seatsBuying.includes(`${rowIndex+1}_${colIndex+1}`);
                      const color = isNormalPurchased ?'#E74C3C': isSubscriberPurchased ? '#9B59B6' : isBuying?'#F6C042': isSelected ? '#3498DB': '#34C759';
                      const isHidden =
                        zone.seat[0].seat_map[rowIndex].layout[colIndex] === '_';

                      if (isHidden) return <div key={colIndex} className="w-14 h-14"></div>;

                      counter++;

                      return (
                        <div
                          key={colIndex}
                          className="relative w-14 h-14"
                          onClick={() => (isBuying || isNormalPurchased || isSubscriberPurchased)?null:handleSelect(`${rowIndex+1}_${colIndex+1}`)}
                        >
                          <SeatSvg backgroundColor={color} />
                          <div className={`absolute inset-0 flex items-center justify-center text-[0.7rem] font-bold ${(isBuying || isNormalPurchased || isSubscriberPurchased)?'cursor-not-allowed': 'cursor-pointer'} transition text-white`}>
                            {seatLabel}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <div className="flex justify-evenly items-center h-full">
        <ButtonSecondary className="" onClick={handleCancel}>Cancelar</ButtonSecondary>
        <ButtonPrimary className="" onClick={handleSave}>Guardar</ButtonPrimary>
      </div>
      {alert && (
        <div className="fixed bottom-8 left-1/2 transform -translate-x-1/2 bg-red-600 text-white px-6 py-3 rounded-2xl shadow-2xl transition-all duration-300 ease-in-out opacity-90 hover:opacity-100 hover:scale-105 flex items-center gap-4">
          {alert}
        </div>
      )}
    </div>
  );
};




